<template>
  <div class="sheet-container" v-safe-area-bottom>
    <div class="sheet-title">
      <strong>목차</strong>
      <img :src="require('@/tarot_box/pages/box_result_v2/assets/xbutton.svg')" alt="close" @click="$emit('close')"/>
    </div>
    <div class="sheet-content">
      <div v-for="(item, index) in filteredPageData" :key="index" class="index-item" @click="goPage(item.page_index + 1)">
        <div class="item-texts">
          <span class="gray6 font12 texts" style="display: flex; flex-direction: row; align-items: center;">
            <strong>{{ item.chapter || `Chapter ${index + 1}` }}</strong>
                        <img :src="require('@/tarot_box/pages/box_result_v2/assets/bottom-sheet/index_new_badge.svg')"
                             alt="new-badge"
                             style="margin-left: 6px;"
                             v-if="checkUnreadExtraQuestion(item.page_index)" />
          </span>
          <span style="display: flex; flex-direction: row; align-items: center;">
            {{ item.page_title }}
          </span>
        </div>
        <div class="item-index" >
          <div class="gray5 font14">{{item.page_index}}</div>
          <img src="../../assets/bottom-sheet/arrow-r.svg" alt="arrow" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { hasUnreadExtraQuestion } from '@/tarot_box/utils/pageHistoryStorage';
import { logEvent } from "@/tarot_box/helper/native_api"; // 추가

export default {
  name: 'IndexComponent',
  props: {
    payload: {
      type: Object,
    },
    resultPageData: {
      type: Object,
    },
    tarotBoxHistory: {
      type: Object,
    }
  },

  data() {
    return {
      refreshKey: 0  // 강제 재계산용
    }
  },

  watch: {
    tarotBoxHistory: {
      handler() {
        console.log('tarotBoxHistory changed!');
        this.refreshKey++;  // computed 강제 재계산
      },
      deep: true,
      immediate: true  // 컴포넌트 생성 시 즉시 실행
    },
  },

  computed: {
    filteredPageData() {
      return this.resultPageData
          .filter(item => item.page_type === 'title_page')
          .map(item => {
            if (item.page_title === '부록') {
              return {
                ...item,
                chapter: '부록',
                page_title: '속시원한 심층풀이'
              };
            }
            return item;
          });
    },

    // 읽지 않은 페이지 맵 (캐싱)
    unreadPagesMap() {
      // refreshKey를 참조해서 강제 재계산
      const key = this.refreshKey;
      console.log('Computing unreadPagesMap, refresh:', key);

      const map = {};
      const historyId = this.tarotBoxHistory?.id;

      if (!historyId) return map;

      // 모든 페이지를 미리 체크해서 맵으로 저장
      this.filteredPageData.forEach(item => {
        const answerPageIndex = item.page_index + 1;
        map[item.page_index] = hasUnreadExtraQuestion(historyId, answerPageIndex);
      });

      console.log('Unread pages map updated:', map);
      return map;
    }
  },

  methods: {
    goPage(index) {
      // 클릭한 아이템의 정보 찾기
      const clickedItem = this.filteredPageData.find(item => item.page_index + 1 === index);
      // 읽지 않은 추가 질문이 있는 경우 로그 이벤트 발생
      if (clickedItem && this.checkUnreadExtraQuestion(clickedItem.page_index)) {
        const chapter = clickedItem.chapter || `Chapter ${this.filteredPageData.indexOf(clickedItem) + 1}`;
        logEvent('result_index_popup_new_click', { chapter: chapter });
      }

      this.$emit("go-page", index);
    },

    checkUnreadExtraQuestion(pageIndex) {
      return this.unreadPagesMap[pageIndex] || false;
    }
  }
}
</script>

<style scoped>
.sheet-container{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;
  padding: 12px 24px;
  margin-bottom: 65px;
  box-sizing: border-box;
  position: relative;
}

.sheet-title{
  font-family: "SUIT Variable", sans-serif;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  padding: 30px 20px 10px 20px;
  box-sizing: border-box;
  background: white;
  z-index: 9999;
}

.sheet-content{
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: 100%;

  margin-top: 60px;
}

.index-item {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  padding: 16px 0;
  box-sizing: border-box;
  border-top: 1px solid var(--Grayscale-Gray10);
  position: relative;
  font-family: "SUIT Variable", sans-serif;

}

.item-texts{
  display: flex;
  flex-direction: column;
  gap: 4px;
  text-align: left;
  width: calc(100% - 30px);
}

.item-index{
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 8px;
}

.texts{
  font-family: "SUIT Variable", sans-serif;
  margin-right: 20px;
}

span{
  font-family: "SUIT Variable", sans-serif;
}
</style>